import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1821.62933,637.76 C1821.62933,507.733333 1778.00267,401.386667 1705.576,318.08 C1717.20267,287.893333 1755.92267,166.72 1694.376,2.77333333 C1694.376,2.77333333 1599.656,-29.2266667 1383.976,124.906667 C1293.84267,98.4533333 1197.20267,85.2266667 1101.20267,84.8 C1005.20267,85.2266667 908.562667,98.4533333 818.536,124.906667 C602.749333,-29.2266667 507.922667,2.77333333 507.922667,2.77333333 C446.376,166.72 485.202667,287.893333 496.829333,318.08 C424.509333,401.386667 380.562667,507.733333 380.562667,637.76 C380.562667,1094.29333 644.242667,1196.48 895.016,1226.56 C895.016,1226.56 714.749333,1338.24 714.749333,1525.97333 C650.429333,1556.48 378.216,1649.92 277.416,1467.84 C277.416,1467.84 217.789333,1353.49333 104.402667,1345.06667 C104.402667,1345.06667 -5.89066667,1343.57333 96.616,1417.49333 C96.616,1417.49333 170.642667,1454.18667 222.056,1591.78667 C222.056,1591.78667 279.229333,1881.70667 711.122667,1751.46667 C715.496,1753.70667 712.722667,1891.73333 712.722667,1920 L1489.896,1920 C1489.896,1920 1491.176,1642.98667 1491.176,1554.88 C1491.176,1338.24 1346.536,1262.4 1305.896,1225.6 C1557.52267,1196.16 1821.62933,1095.46667 1821.62933,637.76",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconGithubSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconGithubSolid, _Component);

  var _super = _createSuper(IconGithubSolid);

  function IconGithubSolid() {
    _classCallCheck(this, IconGithubSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconGithubSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconGithub",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconGithubSolid.displayName = "IconGithubSolid";
  return IconGithubSolid;
}(Component);

IconGithubSolid.glyphName = 'github';
IconGithubSolid.variant = 'Solid';
IconGithubSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconGithubSolid;
export { IconGithubSolid };